
const window = require('window');

const $ = require('jquery');
// HACK
$(window.document).on('click.page-my-common.button-href', 'button[href]', function () {
	const $this = $(this);

	if ($this.is('.disabled')) {
		return;
	}

	if ($this.attr('target') === '_blank') {
		window.open($this.attr('href'), '_blank');
	} else {
		window.location.href = $this.attr('href');
	}
});


